var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { pick } from "lodash";
import MobileOrderSummary from "../../components/OrderSummary/MobileOrderSummary";
import OrderSummary from "../../components/OrderSummary/OrderSummary";
var OrderSummaryContainer = /** @class */ (function (_super) {
    __extends(OrderSummaryContainer, _super);
    function OrderSummaryContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderSummaryContainer.prototype.render = function () {
        var _a = this.props, isMobile = _a.isMobile, walletBalanceToUse = _a.walletBalanceToUse;
        var paymentProps = pick(this.props, ["deal", "email", "error"]);
        if (isMobile) {
            return React.createElement(MobileOrderSummary, __assign({ walletBalanceToUse: walletBalanceToUse }, paymentProps));
        }
        return React.createElement(OrderSummary, __assign({ walletBalanceToUse: walletBalanceToUse }, paymentProps));
    };
    OrderSummaryContainer.defaultProps = {
        products: [],
        isMobile: false,
        deal: null,
        walletBalanceToUse: 0
    };
    return OrderSummaryContainer;
}(Component));
export default OrderSummaryContainer;
